import { computed, onBeforeMount, ref } from "vue";
import { tag as tagEn } from "@/locales/enUS/tag";
import { useGlobalUser } from "@/stores/globalUser";
import { useI18n } from "vue-i18n";
import { usePopular } from "@/stores/popular";
import merge from "lodash.merge";

interface Tag {
  label: string;
  value: string;
  unfiltered?: boolean;
  count?: number;
  isPreset?: boolean;
}

export const usePresetTags = () => {
  const userStore = useGlobalUser();
  const popularStore = usePopular();
  const { t } = useI18n();
  const presetTags = computed(() => {
    return Object.keys(tagEn)
      .filter((key) => (userStore.isCNUser ? !tagEn[key].nsfw : true))
      .map((key) => ({
        label: t(`tag.${key}.value`),
        value: key,
        unfiltered: tagEn[key].nsfw,
        isPreset: true,
      }));
  });
  const mergedTagObj = ref<Record<string, Tag>>({});

  const mergedTags = computed(() => {
    initMergedTagObj();
    return Object.values(mergedTagObj.value).sort((a, b) => {
      // 优先展示isPreset为true的item，其次展示count大的
      if (a.isPreset && !b.isPreset) {
        return -1;
      } else if (!a.isPreset && b.isPreset) {
        return 1;
      } else {
        return (b.count || 0) - (a.count || 0);
      }
    });
  });

  const initMergedTagObj = () => {
    popularStore.mateTagList
      .filter((item) => item.tag)
      .map(
        (tag) =>
          ({
            label: tag.tag,
            value: tag.tag,
            count: tag.count,
          } as Tag)
      )
      .forEach((item) => {
        mergedTagObj.value[item.value] = item;
      });
    const presetTagObj: Record<string, Tag> = {};
    presetTags.value.forEach((item) => {
      presetTagObj[item.value] = item;
    });
    merge(mergedTagObj.value, presetTagObj);
  };

  onBeforeMount(() => {
    initMergedTagObj();
  });
  return { presetTags, mergedTags, mergedTagObj };
};
